import React, { useEffect, useState } from 'react'
import { endOfWeek, format, startOfWeek } from "date-fns"

import SeletorCliente from 'entity/Cliente/components/SeletorCliente'
import DefaultCrudForm from 'components/form/DefaultCrudForm'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow'
import DateInput from 'components/form/input/DateInput'

import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Accordion, AccordionDetails, AccordionSummary, Alert, Typography } from '@mui/material'
import FilterButtonAutomatizador from './FilterButtonAutomatizador'
import SelectInput from 'components/form/input/SelectInput'

function FiltrosAutomatizadorFrenteInter(props) {
    const { laudos, setLaudos, globalLoading, setGlobalLoading, values: filters, refreshTrigger } = props
    const [msgFilter, setMsgFilter] = useState("")
    const [filtersOld, setFiltersOld] = useState(filters)
    const [numLaudos, setNumLaudos] = useState(0)
    const [isExpanded] = useState(true)

    useEffect(() => {
        if (filters.cliente && laudos.length) {
            setNumLaudos(laudos.length)
        } else {
            setNumLaudos(null)
        }
    }, [laudos, filters.cliente])

    useEffect(() => {
        if (refreshTrigger > 0 && filters.cliente && filters.dataInicio && filters.dataFim) {
            const filterButtonElement = document.querySelector('[data-filter-button-automatizador]');
            if (filterButtonElement) {
                filterButtonElement.click();
            }
        }
    }, [refreshTrigger, filters]);

    return (
        <Accordion sx={{ flex: 1 }} defaultExpanded={isExpanded}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography color="text.secondary">Filtros</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <FormContent sx={{ p: 1, display: "flex", justifyContent: "center", flexWrap: 'wrap' }}>
                    <FormRow>
                        <SeletorCliente sx={{ flex: 1 }} autoSelectOne required />
                        <SelectInput
                            name="status"
                            label="Status"
                            options={["Em Digitação", "Concluído", "Cancelado"]}
                        />
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <DateInput name="dataInicio" label="Data de Início" required />
                            <DateInput name="dataFim" label="Data de Fim" required />
                        </div>
                    </FormRow>

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 15, flexWrap: 'wrap' }}>
                        <FilterButtonAutomatizador
                            filters={filters}
                            setMsgFilter={setMsgFilter}
                            setLaudos={setLaudos}
                            setFiltersOld={setFiltersOld}
                            filtersOld={filtersOld}
                            globalLoading={globalLoading}
                            setGlobalLoading={setGlobalLoading}
                        />

                        {msgFilter ? <Alert severity="warning">{msgFilter}</Alert> : null}

                        {laudos && laudos.length && numLaudos !== null
                            ? <Typography sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: '1em' }} variant="h6">
                                Nº de Laudos: {numLaudos}
                            </Typography>
                            : filters.cliente
                                ? <Typography sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: '1em' }} variant="h6">
                                    - NENHUM LAUDO ENCONTRADO -
                                </Typography>
                                : null
                        }
                    </div>
                </FormContent>
            </AccordionDetails>
        </Accordion>
    )
}

export default function FiltrosAutomatizadorFrente(props) {
    let dateRef = new Date();
    const startDate = startOfWeek(dateRef, { weekStartsOn: 0 })
    const endDate = endOfWeek(startDate, { weekStartsOn: 0 })

    return (
        <DefaultCrudForm
            initialValues={{
                dataInicio: format(startDate, "yyyy-MM-dd"),
                dataFim: format(endDate, "yyyy-MM-dd")
            }}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
        >
            {(propsForm) => {
                return <FiltrosAutomatizadorFrenteInter
                    {...props}
                    {...propsForm}
                />
            }}
        </DefaultCrudForm>
    )
}